import { render, staticRenderFns } from "./AccelerationDistanceZoneChart.vue?vue&type=template&id=0964be80"
import script from "./AccelerationDistanceZoneChart.vue?vue&type=script&lang=js"
export * from "./AccelerationDistanceZoneChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports